var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.pageInfo.page_name))])]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.pageInfo.page_content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }